module.exports = __webpack_public_path__ + "static/media/electrical-system-articles.a4e056f9.jpg";